module.exports = __webpack_public_path__ + "media/application/images/ui/menu-tile-c49f3104f6a7ac3a00f66397d37839d4.svg";